import { toLocaleString } from "@circle-react/helpers/number";
import { planFeatures } from "@circle-react/helpers/plansHelpers";

import { t } from "@/i18n-js/instance";

import { FeatureRow } from "../FeatureRow";
import { PlanFeatureFlag } from "../PlanFeatureFlag";
import { SectionWrapper } from "./SectionWrapper";

export const AiFeatures = () => {
  const creditsMapper = (value: number) =>
    `${toLocaleString(value)}${t("pricing_plans.feature.circle_ai_credits_suffix")}`;

  return (
    <SectionWrapper sectionName={t("pricing_plans.section.ai")}>
      <FeatureRow
        title={t("pricing_plans.feature.circle_ai")}
        basic={false}
        professional
        business
        enterprise
        plus
      />
      <PlanFeatureFlag
        title={t("pricing_plans.feature.circle_ai_credits")}
        tooltipKey="pricing_plans.feature.circle_ai_credits_tooltip"
        feature={planFeatures.monthly_ai_credit_allotment}
        mapper={creditsMapper}
      />

      <FeatureRow
        title={t("pricing_plans.feature.content_co_pilot")}
        basic={false}
        professional
        business
        enterprise
        plus
      />

      <FeatureRow
        title={t("pricing_plans.feature.automated_transcriptions")}
        basic={false}
        professional
        business
        enterprise
        plus
      />

      <FeatureRow
        title={t("pricing_plans.feature.activity_scores")}
        basic={false}
        professional
        business
        enterprise
        plus
      />

      <FeatureRow
        title={t("pricing_plans.feature.ai_summaries")}
        basic={false}
        professional
        business
        enterprise
        plus
      />
      <FeatureRow
        title={t("pricing_plans.feature.ai_agents")}
        basic={false}
        professional={false}
        business={false}
        enterprise
        plus
      />
      <FeatureRow
        title={t("pricing_plans.feature.ai_moderation")}
        basic={false}
        professional={false}
        business={false}
        enterprise
        plus
      />
      <FeatureRow
        title={t("pricing_plans.feature.knowledge_engine")}
        basic={false}
        professional={false}
        business={false}
        enterprise
        plus
      />

      <FeatureRow
        title={t("pricing_plans.feature.ai_inbox")}
        basic={false}
        professional={false}
        business={false}
        enterprise
        plus
      />
      <FeatureRow
        title={t("pricing_plans.feature.ai_workflows")}
        basic={false}
        professional={false}
        business={false}
        enterprise
        plus
      />
    </SectionWrapper>
  );
};
